import { FormLabel } from '@mui/material'
import styled from 'styled-components'

export const BaseFormLabel = styled(FormLabel)`
  display: flex;
  align-items: center;
`
